import { render, staticRenderFns } from "./Blazon2.vue?vue&type=template&id=1c9c7cc3&"
import script from "./Blazon2.vue?vue&type=script&lang=js&"
export * from "./Blazon2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports